import { ComboboxContentProps } from 'components/ui/Forms';
import { Driver } from 'contracts/Drivers';
import { useAuth } from 'hooks/auth';
import { api } from 'services/api';

interface GetDriversResponse {
  driverOptions: ComboboxContentProps[];
  drivers: any[];
}

export function useDriver() {
  const { token } = useAuth();
  const getDrivers = async (): Promise<GetDriversResponse> => {
    const { data: drivers } = await api.get<Driver[]>(
      `/drivers?asList=true`,
      {}
    );

    return {
      driverOptions: drivers.map((driver) => ({
        name: driver.name,
        value: String(driver.id),
      })),
      drivers,
    };
  };

  const findDriver = async (code: string): Promise<any> => {
    const { data: driver } = await api.get<any>(`/driver/${code}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return driver;
  };

  return { getDrivers, findDriver };
}
